export enum OrbitApproveRewardStep {
  NOT_AVAILABLE,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  APPROVED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  REJECTED_BY_THE_USER,
}
